import ActionConsumptionProgressWidget from "./ActionConsumptionProgressWidget";
import ActionSummaryChartWidget from "./action-summary/ActionSummaryChartWidget";
import WidgetContainer from "components/common/WidgetContainer";
import TokenSummary from "./TokenSummary";
import Loader from "components/common/controls/Loader";
import {
  getSubscriptionConsumptionSummaryByDayApplyingFilter,
  loadDashboardData,
  setChartViewModeFilter,
  setFromAndToDateFilter,
  setSelectedTagsFilter,
} from "store/slices/DashboardSlice";
import { connect } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import { Component } from "react";
import DailyConsumptionSummary from "interfaces/response/DailyConsumptionSummary";
import { ActionSummaryChartFilterConfig } from "interfaces/ActionSummaryChartFilterConfig";
import { isSame } from "shared/utility/CommonUtility";
import { Moment } from "moment";

interface State {
  isDashboardDataLoaded: boolean;
}

interface Props {
  consumptionSummaryData: DailyConsumptionSummary[];
  actionSummaryChartFilterConfig: ActionSummaryChartFilterConfig;
  licenseKeyTags: string[];
  isDashboardDataLoading: boolean;
  currentSubscriptionId: number;
  dispatch: AppDispatch;
}

export class Dashboard extends Component<Props, State> {
  state: Readonly<State> = {
    isDashboardDataLoaded: false,
  };

  checkIfFiltersAreUpdated(prevProps: Props) {
    return !isSame(
      prevProps.actionSummaryChartFilterConfig,
      this.props.actionSummaryChartFilterConfig
    );
  }

  loadSubscriptionSummaryIfFiltersAreUpdated(prevProps: Props) {
    if (
      this.checkIfFiltersAreUpdated(prevProps) &&
      this.props.currentSubscriptionId
    ) {
      this.props.dispatch(
        getSubscriptionConsumptionSummaryByDayApplyingFilter()
      );
    }
  }

  handleTagSelectionChange = (selectedTags: string[]) => {
    this.props.dispatch(setSelectedTagsFilter(selectedTags));
  };

  handleChartViewModeChange = (viewMode: string) => {
    this.props.dispatch(setChartViewModeFilter(viewMode));
  };

  handleFilterDateChange = (fromDate: Moment, toDate: Moment) => {
    this.props.dispatch(
      setFromAndToDateFilter({
        fromDate: fromDate.format("YYYY/MM/DD"),
        toDate: toDate.format("YYYY/MM/DD"),
      })
    );
  };

  loadAllRelatedData = () => {
    if(this.props.currentSubscriptionId){
      this.setState({ isDashboardDataLoaded: false });
      this.props.dispatch(loadDashboardData()).finally(() => {
        this.setState({ isDashboardDataLoaded: true });
      });
    }
  }

  componentDidMount() {
    if(this.props.currentSubscriptionId){
      this.loadAllRelatedData();
    }
  }

  componentDidUpdate(prevProps: Props) {
    this.loadSubscriptionSummaryIfFiltersAreUpdated(prevProps);
    // Load dashboard data again if currentSubscriptionId is updated in store(currentSubscription loaded).
    if (prevProps.currentSubscriptionId !== this.props.currentSubscriptionId) {
      this.loadAllRelatedData();
    }
  }

  render() {
    return (
      <>
        {this.state.isDashboardDataLoaded ? (
          <>
            <WidgetContainer>
              <ActionConsumptionProgressWidget />
            </WidgetContainer>
            <WidgetContainer>
              <TokenSummary />
            </WidgetContainer>
            <WidgetContainer>
              <ActionSummaryChartWidget
                consumptionSummaryData={this.props.consumptionSummaryData}
                licenseKeyTags={this.props.licenseKeyTags}
                actionSummaryChartFilterConfig={
                  this.props.actionSummaryChartFilterConfig
                }
                onChartViewModeChange={this.handleChartViewModeChange}
                onDateRangeChange={this.handleFilterDateChange}
                onTagSelectionChange={this.handleTagSelectionChange}
              />
            </WidgetContainer>
          </>
        ) : (
          <></>
        )}
        <Loader
          isVisible={
            !this.state.isDashboardDataLoaded ||
            this.props.isDashboardDataLoading
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    consumptionSummaryData: state.dashboardData.consumptionSummariesByDay,
    actionSummaryChartFilterConfig:
      state.dashboardData.actionSummaryChartFilter,
    licenseKeyTags: state.dashboardData.licenseKeyTags,
    isDashboardDataLoading: state.dashboardData.loading,
    currentSubscriptionId: state.subscriptionData.selectedProductSubscriptionId,
  };
};

export default connect(mapStateToProps)(Dashboard);
